const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

// HTTP and WebSocket connections must interpret persisted sessions identically.
// Validate only transport fields here; full session validation belongs to restoration.
export function getSessionAuthorization(storedSession: string | null) {
  const emptyAuthorization = { Authorization: '', tenant_id: undefined };
  if (!storedSession) return emptyAuthorization;

  try {
    const session: unknown = JSON.parse(storedSession);
    if (!isRecord(session) || !isRecord(session.tokens) || !isRecord(session.user))
      return emptyAuthorization;

    const { tokens, user } = session;
    let tenantId: number | undefined;
    if (user.tenant != null) {
      if (
        !isRecord(user.tenant) ||
        typeof user.tenant.id !== 'number' ||
        !Number.isFinite(user.tenant.id)
      )
        return emptyAuthorization;
      tenantId = user.tenant.id;
    }

    const idToken = typeof tokens.id_token === 'string' ? tokens.id_token : undefined;
    const accessToken = typeof tokens.access_token === 'string' ? tokens.access_token : undefined;
    const token = idToken ?? accessToken;
    return { Authorization: token ? `Bearer ${token}` : '', tenant_id: tenantId };
  } catch {
    return emptyAuthorization;
  }
}
